export function Dice({ value, rolling, size = 'md' }) {
  const sizeClasses = {
    sm: 'w-8 h-8 text-lg',
    md: 'w-12 h-12 text-2xl',
    lg: 'w-16 h-16 text-3xl'
  };

  return (
    <div
      className={`${sizeClasses[size]} bg-amber-50 border-2 border-amber-800 rounded-lg flex items-center justify-center font-bold text-amber-900 shadow-md ${rolling ? 'animate-bounce' : ''}`}
      role="img"
      aria-label={`Dice showing ${value}`}
    >
      {value}
    </div>
  );
}
